var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}},_vm.$listeners),[_c('path',{attrs:{"d":"M29.6 97.6l44.2-44.4c.9-.9 1.3-2.1 1.3-3.3 0-1.2-.5-2.4-1.3-3.3L29.6 2.4c-1.1-1.1-2.8-1.1-3.9 0-.5.5-.8 1.2-.8 1.9s.3 1.4.8 1.9l43.6 43.6-43.6 43.9c-1.1 1.1-1.1 2.8 0 3.9s2.8 1.1 3.9 0z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }